// src/env/index.ts
function readEnvKey(source, name) {
  const candidates = [`VITE_${name}`, `REACT_APP_${name}`, name];
  for (const c of candidates) {
    const v = source[c];
    if (v !== void 0 && v !== "") return String(v);
  }
  return void 0;
}
function normaliseDeployEnv(value) {
  const v = (value ?? "local").toLowerCase();
  const known = ["local", "dev", "sandbox", "qa", "staging", "prd"];
  if (known.includes(v)) return v;
  if (v === "production" || v === "prod") return "prd";
  if (v === "development") return "dev";
  return "local";
}
function resolveEnv(source = {}) {
  const raw = {};
  for (const [k, v] of Object.entries(source)) raw[k] = v === void 0 ? void 0 : String(v);
  const apiBaseDomain = readEnvKey(source, "API_BASE_URL") ?? "authe.io";
  return {
    env: normaliseDeployEnv(readEnvKey(source, "ENV")),
    apiBaseDomain,
    claimsNamespace: readEnvKey(source, "BASE_URL") ?? "https://authe.io",
    sourcePlatform: readEnvKey(source, "SOURCE_PLATFORM") ?? "dashboard",
    policyCdnUrl: readEnvKey(source, "POLICY_CDN_URL") ?? `https://cdn.${apiBaseDomain}`,
    privateApiGraphqlUrl: readEnvKey(source, "PRIVATE_API_GRAPHQL_URL"),
    auth0Domain: readEnvKey(source, "AUTH0_DOMAIN"),
    auth0ClientId: readEnvKey(source, "AUTH0_CLIENT_ID"),
    auth0Audience: readEnvKey(source, "AUTH0_AUDIENCE"),
    sentryDsn: readEnvKey(source, "SENTRY_DSN"),
    rumAppId: readEnvKey(source, "RUM_APP_ID"),
    rumIdentityPoolId: readEnvKey(source, "RUM_IDENTITY_POOL_ID"),
    rumRegion: readEnvKey(source, "RUM_REGION"),
    raw
  };
}
function isProd(env) {
  return env.env === "prd";
}
function isLocal(env) {
  return env.env === "local";
}
function isSandbox(env) {
  return env.env === "sandbox";
}
function isQa(env) {
  return env.env === "qa";
}

export { isLocal, isProd, isQa, isSandbox, readEnvKey, resolveEnv };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map